import { Themed } from "@client/styles/themes";
import React from "react";

import { RichText } from "../RichText";

import styles from "./index.module.scss";

export const NotFound = () => {
    return (
        <Themed theme="robinsBlue" className={styles.root}>
            <p className={styles.oops}>OOPS</p>
            <RichText
                className={styles.content}
                headingSize="large"
                value={`<h1>Page not found</h1><p><a class="buttonFilled linkReset" href="/">GO TO HOMEPAGE</a></p>`}
            />
        </Themed>
    );
};
